export const breakpoint = {
  sm: "only screen and (max-width: 37rem)",
  md: "only screen and (max-width: 45rem)",
  lg: "only screen and (max-width: 62rem)",
}
